import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRoute() {
  const token = localStorage.getItem('admin_token');

  // Wenn kein Token vorhanden ist, zurück zum Admin-Login leiten
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // Wenn ein Token existiert, die geschützte Route (Dashboard etc.) anzeigen
  return <Outlet />;
}
